// src/components/FilterSidebar/FilterSidebar.jsx

import React from 'react'; // React.Fragment için
import './FilterSidebar.css';

function FilterSidebar({
  categories,
  brands,
  selectedCategories,
  selectedBrands,
  priceRange,
  sortBy,
  onCategoryChange,
  onBrandChange,
  onPriceChange,
  onSortChange,
  onClearFilters,
  loading,
  selectedSubCategories,
  onSubCategoryChange
}) {

  // Kategori checkbox'ı için handle fonksiyonu
  const handleCategoryCheckbox = (e) => {
    onCategoryChange(e.target.value); // Değer kategori ismi
  };

  // Marka checkbox'ı için handle fonksiyonu
  const handleBrandCheckbox = (e) => {
    onBrandChange(e.target.value); // Değer marka ID'si
  };
  
  // Alt Kategori checkbox'ı için handle fonksiyonu
  const handleSubCategoryCheckbox = (e) => {
    onSubCategoryChange(e.target.value); // Değer alt kategori ismi
  };

  if (loading) {
    return <aside className="filter-sidebar is-loading">Filtreler Yükleniyor...</aside>;
  }

  return (
    <aside className="filter-sidebar">
      
      {/* Sıralama */}
      <div className="filter-section">
        <label htmlFor="sort-by" className="filter-title">Sırala</label>
        <select id="sort-by" value={sortBy} onChange={onSortChange}>
          <option value="newest">En Yeniler</option>
          <option value="price-asc">Fiyata Göre Artan</option>
          <option value="price-desc">Fiyata Göre Azalan</option>
        </select>
      </div>

      {/* Kategoriler (İç İçe Listeleme) */}
      <div className="filter-section">
        <h3 className="filter-title">Kategoriler</h3>
        <ul className="filter-list">
          {categories.map(cat => (
            // Her kategori için bir Fragment (grup) oluştur
            <React.Fragment key={cat.id}>
              
              {/* 1. Ana Kategori (Ocaklar, Eviyeler vs.) */}
              <li>
                <label className="main-category-label">
                  <input 
                    type="checkbox" 
                    value={cat.name} 
                    checked={selectedCategories.includes(cat.name)}
                    onChange={handleCategoryCheckbox}
                  />
                  {cat.name}
                </label>
              </li>
              
              {/* 2. Alt Kategori (Varsa gösterir, yoksa atlar) */}
              {cat.subCategories && cat.subCategories.length > 0 && (
                <ul className="filter-subcategory-list">
                  {cat.subCategories.map(subCat => (
                    <li key={subCat.id}>
                      <label className="sub-category-label">
                        <input 
                          type="checkbox" 
                          value={subCat.name} 
                          checked={selectedSubCategories.includes(subCat.name)}
                          onChange={handleSubCategoryCheckbox}
                        />
                        {subCat.name}
                      </label>
                    </li>
                  ))}
                </ul>
              )}
            </React.Fragment>
          ))}
        </ul>
      </div>

      {/* Markalar */}
      <div className="filter-section">
        <h3 className="filter-title">Markalar</h3>
        <ul className="filter-list">
          {brands.map(brand => (
            <li key={brand.id}>
              <label>
                <input 
                  type="checkbox" 
                  value={brand.id} 
                  checked={selectedBrands.includes(brand.id)}
                  onChange={handleBrandCheckbox}
                />
                {brand.name}
              </label>
            </li>
          ))}
        </ul>
      </div>

      {/* Fiyat Aralığı */}
      <div className="filter-section">
        <h3 className="filter-title">Fiyat Aralığı (TL)</h3>
        <div className="price-range-filter">
          <input 
            type="number" 
            name="min"
            placeholder="Min" 
            value={priceRange.min}
            onChange={onPriceChange} 
            min="0"
          />
          <span>-</span>
          <input 
            type="number" 
            name="max"
            placeholder="Max" 
            value={priceRange.max}
            onChange={onPriceChange} 
            min="0"
          />
        </div>
      </div>

      {/* Filtreleri Temizle Butonu */}
      <button className="clear-filters-btn" onClick={onClearFilters}>
        Filtreleri Temizle
      </button>

    </aside>
  );
}

export default FilterSidebar;